export default function getDefaultCalendarThemeOptions () {
    return {
      dataLabels: {
        dropShadow: {
          enabled: false,
        },
      },
        labels: [
            'Google',
            'Apple',
            'Outlook.com (Web)',
            'Outlook',
            'Outlook-new',
            'Microsoft 365',
            'ICS',
            'Other',
        ],
        responsive: [
            {
                breakpoint: 480,
                options: {
                    chart: {
                        width: '100%',
                    },
                    legend: {
                        position: 'left',
                    },
                },
            },
        ],
        colors: [
            '#00d456',
            '#ff9e00',
            '#00d7ff',
            '#ff9e00',
            '#F50057',
            '#FEC260',
            '#00d456',
            '#00d7ff',
        ],
        states: {
          normal: {
              filter: {
                  type: 'none',
                  value: 0,
              },
          },
          hover: {
              filter: {
                  type: 'lighten',
                  value: -0.2,
              },
          },
          active: {
              allowMultipleDataPointsSelection: false,
              filter: {
                  type: 'lighten',
                  value: -0.4,
              },
          },
        },
    };
};
